"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
function ResetPasswordEvent(updateCallback, user, resources) {
    var _this = this;
    var resetPasswordEventContentRef = React.createRef();
    var actions = [];
    var content = user.displayName + " " + (resources.AlreadyPedningPasswordReset || "already has a password reset pending.");
    if (!user.passwordReset) {
        actions.push(new Types_1.VeriLiteEventAction(resources.Reset, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                (_a = resetPasswordEventContentRef.current) === null || _a === void 0 ? void 0 : _a.checkReset();
                return [2 /*return*/];
            });
        }); }));
        content = React.createElement(ResetPasswordEventContent, { ref: resetPasswordEventContentRef, updateCallback: updateCallback, user: user, resources: resources });
    }
    actions.push(new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
        closeModalCallback();
    }));
    return new Types_1.VeriLiteWarningEvent(content, resources.ResetPassword, actions);
}
exports.ResetPasswordEvent = ResetPasswordEvent;
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState || (InputValidationState = {}));
var ResetPasswordEventContentState;
(function (ResetPasswordEventContentState) {
    ResetPasswordEventContentState[ResetPasswordEventContentState["Initial"] = 0] = "Initial";
    ResetPasswordEventContentState[ResetPasswordEventContentState["Confirm"] = 1] = "Confirm";
    ResetPasswordEventContentState[ResetPasswordEventContentState["Pending"] = 2] = "Pending";
    ResetPasswordEventContentState[ResetPasswordEventContentState["Success"] = 3] = "Success";
    ResetPasswordEventContentState[ResetPasswordEventContentState["Error"] = 4] = "Error";
})(ResetPasswordEventContentState || (ResetPasswordEventContentState = {}));
var ResetPasswordEventContent = /** @class */ (function (_super) {
    __extends(ResetPasswordEventContent, _super);
    function ResetPasswordEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.error = {};
        _this.isValid = function (input) {
            return input === InputValidationState.valid;
        };
        _this.isInvalid = function (input) {
            return input === InputValidationState.invalid;
        };
        _this.clearValidation = function () {
            _this.setState({
                ValidationState: {
                    Error: "",
                    State: InputValidationState.unset
                }
            });
        };
        _this.validateInput = function () {
            if (typeof _this.state.UserDisplayName !== "string" || _this.state.UserDisplayName === undefined || _this.state.UserDisplayName === null || _this.state.UserDisplayName === "") {
                _this.updateValidation({ value: _this.props.resources.Registration_Validation_RequiredField });
                return false;
            }
            else if (_this.state.UserDisplayName !== _this.props.user.displayName.toUpperCase()) {
                _this.updateValidation({ value: _this.props.resources.NameDoesNotMatch });
                return false;
            }
            return true;
        };
        _this.updateValidation = function (validationResponse) {
            _this.setState({
                ValidationState: {
                    Error: validationResponse.value,
                    State: InputValidationState.invalid
                }
            });
        };
        _this.checkReset = function () { return __awaiter(_this, void 0, void 0, function () {
            var userId, options, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearValidation();
                        if (!this.validateInput()) {
                            return [2 /*return*/];
                        }
                        userId = this.props.user.id;
                        if (this.state.status == ResetPasswordEventContentState.Initial && userId == AuthenticationService_1.Auth.getUser().id) {
                            this.updateModal(ResetPasswordEventContentState.Confirm);
                            return [2 /*return*/];
                        }
                        this.updateModal(ResetPasswordEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/users/Check?id=" + userId, options).then(function (response) {
                            if (!response.ok) {
                                switch (response.status) {
                                    case 500:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.ServerErrorMessage;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        });
                                        break;
                                    default:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        });
                                        break;
                                }
                            }
                            else {
                                response.json().then(function (userIsLoggedIn) {
                                    if (userIsLoggedIn) {
                                        _this.updateModal(ResetPasswordEventContentState.Confirm);
                                    }
                                    else {
                                        _this.resetPassword();
                                    }
                                });
                            }
                        }).catch(function (err) {
                            console.error("Error checking user:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.resetPassword = function () { return __awaiter(_this, void 0, void 0, function () {
            var userId, options, userRequestHeaders, headers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.clearValidation();
                        if (!this.validateInput()) {
                            return [2 /*return*/];
                        }
                        userId = this.props.user.id;
                        this.updateModal(ResetPasswordEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _a.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/users/ResetPassword?id=" + userId, options).then(function (response) {
                            //console.log(response);
                            if (!response.ok) {
                                switch (response.status) {
                                    case 400:
                                        //console.log("400");
                                        _this.updateModal(ResetPasswordEventContentState.Initial);
                                        response.json().then(function (validationResponse) {
                                            _this.updateValidation(validationResponse);
                                        });
                                        break;
                                    case 402:
                                        //console.log("402");
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        });
                                        break;
                                    case 500:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.ServerErrorMessage;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        });
                                        break;
                                    default:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                                            _this.updateModal(ResetPasswordEventContentState.Error);
                                        });
                                        break;
                                }
                            }
                            else {
                                _this.updateModal(ResetPasswordEventContentState.Success);
                            }
                        }).catch(function (err) {
                            console.error("Error resetting a user:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case ResetPasswordEventContentState.Success:
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case ResetPasswordEventContentState.Confirm:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.ResetPassword;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Confirm, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.resetPassword();
                                return [2 /*return*/];
                            });
                        }); }), new Types_1.VeriLiteEventAction(_this.props.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case ResetPasswordEventContentState.Error:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.error.title || _this.props.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case ResetPasswordEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case ResetPasswordEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.ResetPassword;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Reset, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.checkReset();
                                return [2 /*return*/];
                            });
                        }); }), new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.onChangeHandler = function (event) {
            _this.setState({
                UserDisplayName: event.target.value
            });
        };
        _this.stateBasedRender = function (currentState) {
            switch (currentState) {
                case ResetPasswordEventContentState.Initial:
                    return (React.createElement("div", null,
                        _this.props.resources.ResetPasswordMessage,
                        React.createElement(reactstrap_1.Input, { valid: _this.isValid(_this.state.ValidationState.State), invalid: _this.isInvalid(_this.state.ValidationState.State), placeholder: _this.props.user.displayName.toUpperCase(), onChange: _this.onChangeHandler }),
                        React.createElement(reactstrap_1.FormFeedback, null, _this.isInvalid(_this.state.ValidationState.State) ? _this.state.ValidationState.Error : "")));
                case ResetPasswordEventContentState.Confirm:
                    return (React.createElement("div", null, _this.props.user.id == AuthenticationService_1.Auth.getUser().id ? _this.props.resources.ResetPasswordConfirmMessageSelf : _this.props.user.displayName + " " + _this.props.resources.ResetPasswordConfirmMessage));
                case ResetPasswordEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case ResetPasswordEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                _this.props.resources.ResetPasswordSuccess_1,
                                _this.props.user.displayName,
                                _this.props.resources.ResetPasswordSuccess_2),
                            React.createElement(reactstrap_1.Col, null))));
                default:
                    return (React.createElement("div", null, _this.props.resources.SomethingWentWrong));
            }
        };
        _this.state = {
            UserDisplayName: "",
            ValidationState: {
                Error: "",
                State: InputValidationState.unset
            },
            status: ResetPasswordEventContentState.Initial
        };
        return _this;
    }
    ResetPasswordEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return ResetPasswordEventContent;
}(React.Component));
//# sourceMappingURL=ResetPasswordEvent.js.map